import { message } from 'antd/index';

export const showInfoMessage = (type: string, content: string, time: number = 70): void =>
  message[type]({ content }, time);
